<template>
	<div class="warehouse-buyout">
		<div class="btnbox">
			<el-button size="small" type="primary" @click="goGoods">去商品列表发起</el-button>
		</div>
		<div class="empty-guide" v-if="ready && !warehouseId">
			<div class="empty-title">请先开通云仓</div>
			<div class="empty-desc">开通并通过审核后才能查看变现报价单。</div>
			<el-button type="primary" @click="goIndex">返回云仓首页</el-button>
		</div>
		<div class="tablebox" v-if="ready && warehouseId">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" size="small" label-width="0">
					<el-form-item>
						<el-radio-group v-model="formfilter.state" @change="onfilter">
							<el-radio-button label="">全部</el-radio-button>
							<el-radio-button label="0">待应答</el-radio-button>
							<el-radio-button label="1">已成交</el-radio-button>
							<el-radio-button label="2">已拒绝</el-radio-button>
							<el-radio-button label="3">已失效</el-radio-button>
						</el-radio-group>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onlist">刷新</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%" v-loading="loading">
					<template slot="empty">暂无报价单，请到商品列表发起</template>
					<el-table-column type="expand">
						<template slot-scope="scope">
							<el-table :data="scope.row.items" border size="mini" style="width: 100%">
								<el-table-column prop="style_number" label="款号" min-width="110"></el-table-column>
								<el-table-column prop="size" label="尺码" width="60" align="center"></el-table-column>
								<el-table-column label="报价数" width="70" align="center">
									<template slot-scope="s">{{ s.row.quantity }}</template>
								</el-table-column>
								<el-table-column label="成交数" width="70" align="center">
									<template slot-scope="s">{{ scope.row.state == 1 ? s.row.deal_quantity : '--' }}</template>
								</el-table-column>
								<el-table-column label="扣减单价" width="90" align="center">
									<template slot-scope="s">¥{{ s.row.quote_price_str }}</template>
								</el-table-column>
								<el-table-column label="变现折扣" width="80" align="center">
									<template slot-scope="s">{{ zhe(s.row.quote_discount_str) }}</template>
								</el-table-column>
								<el-table-column label="当前可用" width="80" align="center">
									<template slot-scope="s">{{ s.row.available_quantity }}</template>
								</el-table-column>
							</el-table>
						</template>
					</el-table-column>
					<el-table-column prop="id" label="报价单ID" width="90" align="center"></el-table-column>
					<el-table-column label="报价件数" width="90" align="center">
						<template slot-scope="scope">{{ scope.row.total_quantity }}</template>
					</el-table-column>
					<el-table-column label="扣减合计" width="110" align="center">
						<template slot-scope="scope">¥{{ scope.row.total_quote_str }}</template>
					</el-table-column>
					<el-table-column label="成交件数" width="90" align="center">
						<template slot-scope="scope">{{ scope.row.state == 1 ? scope.row.deal_quantity : '--' }}</template>
					</el-table-column>
					<el-table-column label="实际扣减" width="110" align="center">
						<template slot-scope="scope">{{ scope.row.state == 1 ? '¥' + scope.row.deal_quote_str : '--' }}</template>
					</el-table-column>
					<el-table-column label="状态" width="90" align="center">
						<template slot-scope="scope">
							<span :class="'state-text state-' + scope.row.state">{{ scope.row.state_str }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="create_time_str" label="报价时间" width="160" align="center"></el-table-column>
					<el-table-column prop="handle_time_str" label="处理时间" width="160" align="center"></el-table-column>
				</el-table>
			</div>
			<div class="pagediv">
				<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
					:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
					@current-change="handleCurrentChange" @size-change="handleSizeChange">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import { apiMsg } from './money.js'

	export default {
		name: 'WarehouseBuyout',
		data() {
			return {
				ready: false,
				warehouseId: '',
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,
				loading: false,
				formfilter: {
					state: ''
				}
			}
		},
		mounted() {
			this.onlist()
			this.loadWarehouse()
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect
					if (this.$refs.tablediv) {
						this.$refs.tablediv.style.height = 'calc(100% - ' + (Number(cr.height) + 30) + 'px)'
					}
				}
			})
			this.$nextTick(function() {
				if (this.$refs.filter) {
					this.resizeObserver.observe(this.$refs.filter)
				}
			})
		},
		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect()
			}
		},
		methods: {
			zhe(val) {
				var num = parseFloat(val)
				return isNaN(num) ? '--' : num + '折'
			},
			goIndex() {
				this.$router.push('/buyer/warehouse/index')
			},
			goGoods() {
				this.$router.push('/buyer/warehouse/goods')
			},
			loadWarehouse() {
				this.$axios.get('api/cloud_warehouse/info').then(res => {
					this.ready = true
					if (res.data.code === 0) {
						var info = res.data.data || {}
						this.warehouseId = info.id || ''
						if (this.warehouseId) {
							this.$nextTick(function() {
								if (this.resizeObserver && this.$refs.filter) {
									this.resizeObserver.observe(this.$refs.filter)
								}
							})
						}
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					this.ready = true
					console.log(err)
				})
			},
			onfilter() {
				this.page = 1
				this.onlist()
			},
			handleCurrentChange() {
				this.onlist()
			},
			handleSizeChange(val) {
				this.page = 1
				this.pageSize = val
				this.onlist()
			},
			onlist() {
				this.loading = true
				var params = {
					type: 1,
					page: this.page,
					limit: this.pageSize
				}
				if (this.formfilter.state !== '' && this.formfilter.state !== null) {
					params.state = this.formfilter.state
				}
				this.$axios.get('api/cloud_warehouse/buyout_offer_list', { params: params }).then(res => {
					this.loading = false
					if (res.data.code === 0) {
						var data = res.data.data || {}
						this.list = data.list || []
						this.total = data.count || 0
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					this.loading = false
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.warehouse-buyout {
		height: 100%;
	}

	.empty-guide {
		padding: 80px 20px;
		text-align: center;
		.empty-title {
			font-size: 20px;
			font-weight: 600;
			margin-bottom: 12px;
		}
		.empty-desc {
			color: #909399;
			margin-bottom: 24px;
		}
	}

	.tablebox {
		height: calc(100% - 72px);
	}

	.tablediv {
		height: calc(100% - 52px);
	}

	.state-text {
		&.state-0 { color: #E6A23C; }
		&.state-1 { color: #67C23A; }
		&.state-2 { color: #909399; }
		&.state-3 { color: #909399; }
	}
</style>



// WEBPACK FOOTER //
// src/components/buyer/warehouse/buyout.vue